import { UserInfoRole } from '@space-shell/common/services/user/types'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { UserInfoStoreType, UserInfoType } from './types'

const initialState = {
  role: UserInfoRole.VIEWER,
  name: '',
  avatar: '',
  email: '',
  isAttendant: false,
  isMembership: false
}

export const useUserInfoStore = create<UserInfoStoreType>()(
  devtools((set) => ({
    ...initialState,
    setUserInfo: (userInfo: UserInfoType): void => set({ ...userInfo }),
    resetUserInfo: (): void => set(initialState)
  }))
)
